import type * as EntitlementBundle from '@foundation-player/plugin-entitlement';
import { PluginFactoryFunction } from '../builder-config';
import { PACKAGE_NAME_TO_GLOBAL_NAME, PackageName } from '../package-name';
import { resolveByPackageNameOrThrow } from '../resolve-bundle';

export const createEntitlementPlugin: PluginFactoryFunction = (builderConfig) => {
  const entitlementPackage = PackageName.PluginEntitlement;

  return [
    [entitlementPackage],
    () => {
      const entitlementGlobalName = PACKAGE_NAME_TO_GLOBAL_NAME[entitlementPackage];

      return [
        new (resolveByPackageNameOrThrow<typeof EntitlementBundle>(entitlementPackage).EntitlementPlugin)(
          builderConfig.pluginConfigs[entitlementGlobalName] as EntitlementBundle.PluginConfig,
        ),
      ];
    },
  ];
};
